import { StoreChatlist } from '../../Types/StoreTypes';

export const SET_CHATLIST_OPEN = 'SET_CHATLIST_OPEN';
export const SET_CHATLIST_OPEN_HOVER = 'SET_CHATLIST_OPEN_HOVER';
export const SET_CHATLIST = 'SET_CHATLIST';

export function setChatlistOpen(chatlistOpen: StoreChatlist['chatlistOpen']) {
    return { type: SET_CHATLIST_OPEN, payload: chatlistOpen };
}

export function setChatlistOpenHover(chatlistOpenHover: StoreChatlist['chatlistOpenHover']) {
    return { type: SET_CHATLIST_OPEN_HOVER, payload: chatlistOpenHover };
}

export function setChatlist(chatlist: StoreChatlist['chatlist']) {
    return { type: SET_CHATLIST, payload: chatlist };
}
